// useAllowMeFingerprint.ts
import { useEffect, useState } from "react"

export function useAllowMeFingerprint(context: string) {
  const [fingerprint, setFingerprint] = useState<string | null>(null)

  useEffect(() => {
    const apiKey = process.env.REACT_APP_ALLOWME_API_KEY
    const sdkUrl = process.env.REACT_APP_SDK_JS_URL

    if (!apiKey || !sdkUrl) {
      console.error("⚠️ Variáveis de ambiente AllowMe não configuradas.")
      return
    }

    const script = document.createElement("script")
    script.src = sdkUrl
    script.async = true
    script.defer = true
    script.type = "text/javascript" 

    // Essa função será chamada automaticamente após o SDK carregar
    ;(window as any).alwmAsyncInit = () => {
      console.log("🔄 Iniciando Alwm...")
      ;(window as any).Alwm.init({ apiKey, generateFingerprint: true })
        .then(() => {
          console.log("✅ Alwm inicializado")
          return (window as any).Alwm.collect(context)
        })
        .then((fp: string) => {
          console.log("📎 Fingerprint coletado:", fp)
          setFingerprint(fp)
        })
        .catch((err: any) => {
          console.error("❌ Erro ao iniciar ou coletar fingerprint:", err)
        })
    }

    document.body.appendChild(script)
  }, [context])

  return fingerprint
}
